/** Inclusive booking dates for the one-day free desk trial campaign. */
export const FREE_TRIAL_BOOKING_START_DATE = '2026-10-19';
export const FREE_TRIAL_BOOKING_END_DATE = '2026-10-24';
export const FREE_TRIAL_BOOKING_WINDOW_LABEL = 'October 19–24, 2026';

/** Daily interval in which a visitor may sit for a free trial. */
export const FREE_TRIAL_START_MINUTE = 8 * 60;
export const FREE_TRIAL_END_MINUTE = 18 * 60;
/** Trial times fall on the hour: 8:00, 9:00, 10:00… */
export const FREE_TRIAL_STEP_MINUTES = 60;
export const FREE_TRIAL_EARLIEST_END_MINUTE = FREE_TRIAL_START_MINUTE + FREE_TRIAL_STEP_MINUTES;
export const FREE_TRIAL_LATEST_START_MINUTE = FREE_TRIAL_END_MINUTE - FREE_TRIAL_STEP_MINUTES;
export const FREE_TRIAL_START_TIME = '08:00';
export const FREE_TRIAL_END_TIME = '18:00';
export const FREE_TRIAL_EARLIEST_END_TIME = '09:00';
export const FREE_TRIAL_LATEST_START_TIME = '17:00';
export const FREE_TRIAL_TIME_WINDOW_LABEL = '8:00 AM–6:00 PM';

export function isFreeTrialBookingDate(date: string): boolean {
  return date >= FREE_TRIAL_BOOKING_START_DATE && date <= FREE_TRIAL_BOOKING_END_DATE;
}

export function isFreeTrialTimeRange(startMinute: number, endMinute: number): boolean {
  return (
    startMinute >= FREE_TRIAL_START_MINUTE &&
    endMinute <= FREE_TRIAL_END_MINUTE &&
    endMinute > startMinute &&
    isFreeTrialStep(startMinute) &&
    isFreeTrialStep(endMinute)
  );
}

/** Whether a minute of the day lands on a trial step: 540 (9:00) does, 555 (9:15) does not. */
export function isFreeTrialStep(minute: number): boolean {
  return minute % FREE_TRIAL_STEP_MINUTES === 0;
}
